import { useSyncExternalStore } from "react";
export const useAnnotationStore = (store) => useSyncExternalStore((listener) => store.subscribe(listener), () => store.list(), () => store.list());
//# sourceMappingURL=useAnnotationStore.js.map